import React from 'react';
import { Container } from 'react-bootstrap';
import Logo from '../../../res/MayorX.svg';
import styles from './AuthLoading.module.scss';

const AuthLoading: React.FC = () => {
  return (
    <div className={styles.authLoadingWrapper}>
      <div className={styles.authLoadingContainer}>
        <Container className="d-flex flex-column align-items-center justify-content-center">
          {/* Logo */}
          <div className={styles.logoContainer}>
            <img
              src={Logo}
              alt="Wholesale System Logo"
              className={`${styles.logo} official-logo`}
            />
          </div>

          {/* Loading Animation */}
          <div className={styles.loadingAnimation}>
            <div className={styles.spinnerRing}></div>
            <div className={styles.spinnerRing}></div>
            <div className={styles.spinnerRing}></div>
          </div>

          {/* Loading Message */}
          <div className={styles.loadingMessage}>
            <h4 className={styles.title}>Iniciando sesión...</h4>
            <p className={styles.subtitle}>Verificando credenciales</p>
          </div>

          {/* Progress Dots */}
          <div className={styles.progressDots}>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default AuthLoading;
